/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  var departmentFilterSelector = '.dms-department-filter';
  var departmentLayoutSelector = '.dms-department-layout';
  var filtersSelector = '[data-collection-filters]';
  var filtersFormSelector = '[data-collection-filters-form]';
  var productGridSelector = '[data-collection-products]';
  var nativeFetch = window.fetch.bind(window);
  var departmentResponseCache = new Map();
  var departmentDocumentCache = new Map();
  var nativeParseFromString = DOMParser.prototype.parseFromString;

  document.addEventListener('input', function (event) {
    if (!(event.target instanceof Element) || !event.target.matches('.dms-personalization-field__input[required]')) return;

    if (event.target.value.trim()) {
      event.target.setCustomValidity('');
    } else {
      event.target.setCustomValidity('Please enter the last name for this item.');
    }
  });

  document.addEventListener('click', function (event) {
    var eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
    var acceleratedCheckout = eventPath.find(function (node) {
      return node instanceof Element && (node.matches('.shopify-payment-button') || node.matches('shopify-accelerated-checkout'));
    });
    if (!acceleratedCheckout) return;

    var productForm = acceleratedCheckout.closest('form');
    var requiredPersonalization = productForm && productForm.querySelector('.dms-personalization-field__input[required]');
    if (!requiredPersonalization || requiredPersonalization.value.trim()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    requiredPersonalization.setCustomValidity('Please enter the last name for this item.');
    requiredPersonalization.reportValidity();
    requiredPersonalization.focus();
  }, true);

  /* ── Mug customization: tabs, file upload, character counter ── */

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-mug-tab]');
    if (!tab) return;

    var wrapper = tab.closest('.dms-mug-customization');
    if (!wrapper) return;

    var mode = tab.getAttribute('data-mug-tab'); // 'upload' | 'text'

    // Toggle active tab
    wrapper.querySelectorAll('[data-mug-tab]').forEach(function (t) {
      t.classList.remove('dms-mug-customization__tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('dms-mug-customization__tab--active');
    tab.setAttribute('aria-selected', 'true');

    // Toggle panels
    wrapper.querySelectorAll('[data-mug-panel]').forEach(function (panel) {
      var isTarget = panel.getAttribute('data-mug-panel') === mode;
      panel.classList.toggle('dms-mug-customization__panel--active', isTarget);
      panel.hidden = !isTarget;
    });

    // Clear the inactive panel's inputs so only the chosen method's value submits
    if (mode === 'upload') {
      var textInput = wrapper.querySelector('[data-mug-text-input]');
      if (textInput) textInput.value = '';
      var counter = wrapper.querySelector('[data-mug-char-count]');
      if (counter) counter.textContent = '0 / 500';
    } else {
      var fileInput = wrapper.querySelector('[data-mug-file-input]');
      if (fileInput) fileInput.value = '';
      var preview = wrapper.querySelector('.dms-mug-customization__file-preview');
      if (preview) preview.style.display = 'none';
    }
  });

  // File input change → show preview pill
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-mug-file-input]')) return;
    var wrapper = event.target.closest('.dms-mug-customization');
    if (!wrapper) return;
    var preview = wrapper.querySelector('.dms-mug-customization__file-preview');
    var nameSpan = wrapper.querySelector('[data-mug-file-name]');
    if (event.target.files && event.target.files.length) {
      nameSpan.textContent = event.target.files[0].name;
      preview.style.display = '';
    } else {
      preview.style.display = 'none';
    }
  });

  // Remove file button
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-mug-file-remove]')) return;
    var wrapper = event.target.closest('.dms-mug-customization');
    if (!wrapper) return;
    var fileInput = wrapper.querySelector('[data-mug-file-input]');
    if (fileInput) fileInput.value = '';
    var preview = wrapper.querySelector('.dms-mug-customization__file-preview');
    if (preview) preview.style.display = 'none';
  });

  // Drag-and-drop on dropzone
  document.addEventListener('dragover', function (event) {
    var dropzone = event.target.closest('.dms-mug-customization__dropzone');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.add('dms-mug-customization__dropzone--dragover');
  });

  document.addEventListener('dragleave', function (event) {
    var dropzone = event.target.closest('.dms-mug-customization__dropzone');
    if (!dropzone) return;
    dropzone.classList.remove('dms-mug-customization__dropzone--dragover');
  });

  document.addEventListener('drop', function (event) {
    var dropzone = event.target.closest('.dms-mug-customization__dropzone');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.remove('dms-mug-customization__dropzone--dragover');

    var wrapper = dropzone.closest('.dms-mug-customization');
    var fileInput = wrapper && wrapper.querySelector('[data-mug-file-input]');
    if (!fileInput || !event.dataTransfer.files.length) return;

    fileInput.files = event.dataTransfer.files;
    // Trigger change event so preview updates
    fileInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Textarea character counter
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-mug-text-input]')) return;
    var wrapper = event.target.closest('.dms-mug-customization');
    var counter = wrapper && wrapper.querySelector('[data-mug-char-count]');
    if (counter) {
      counter.textContent = event.target.value.length + ' / 500';
    }
  });

  DOMParser.prototype.parseFromString = function (source, type) {
    if (type === 'text/html' && departmentDocumentCache.has(source)) {
      return departmentDocumentCache.get(source);
    }

    return nativeParseFromString.call(this, source, type);
  };

  function sectionRequestUrl(layout, url) {
    var targetUrl = new URL(url, window.location.origin);
    var searchParams = targetUrl.searchParams.toString();
    return targetUrl.origin + targetUrl.pathname + '?section_id=' + encodeURIComponent(layout.dataset.sectionId) + '&' + searchParams;
  }

  function preloadDepartmentPage(layout, url) {
    var requestUrl = sectionRequestUrl(layout, url);
    if (departmentResponseCache.has(requestUrl)) return departmentResponseCache.get(requestUrl);

    var preloadRequest = nativeFetch(requestUrl, {
      credentials: 'same-origin',
      priority: 'low'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to preload department products');

        return response.text().then(function (body) {
          var parsedDocument = nativeParseFromString.call(new DOMParser(), body, 'text/html');
          departmentDocumentCache.set(body, parsedDocument);

          return {
            body: body,
            status: response.status,
            statusText: response.statusText,
            headers: Array.from(response.headers.entries())
          };
        });
      })
      .catch(function () {
        departmentResponseCache.delete(requestUrl);
        return null;
      });

    departmentResponseCache.set(requestUrl, preloadRequest);
    return preloadRequest;
  }

  // The Palo Alto filter controller still handles rendering and reinitializing
  // product cards. Only its exact department requests are served from memory.
  window.fetch = function (resource, options) {
    var method = options && options.method ? options.method.toUpperCase() : 'GET';
    var resourceUrl = typeof resource === 'string' ? resource : resource && resource.url;
    if (method !== 'GET' || !resourceUrl) return nativeFetch(resource, options);

    var normalizedUrl = new URL(resourceUrl, window.location.origin).href;
    var cachedResponse = departmentResponseCache.get(normalizedUrl);
    if (!cachedResponse) return nativeFetch(resource, options);

    return cachedResponse.then(function (entry) {
      if (!entry) return nativeFetch(resource, options);

      return new Response(entry.body, {
        status: entry.status,
        statusText: entry.statusText,
        headers: entry.headers
      });
    });
  };

  function scheduleDepartmentPreloads(layout, nav) {
    var links = Array.from(nav.querySelectorAll(departmentFilterSelector)).filter(function (link) {
      return !crossesDepartmentTemplate(link.href || link.dataset.url);
    });

    // Render every category response together shortly after the first page is
    // interactive. Shopify's section renderer is slow enough that sequential
    // warming leaves the last category cold for many seconds.
    window.setTimeout(function () {
      links.forEach(function (link) {
        preloadDepartmentPage(layout, link.href || link.dataset.url);
      });
    }, 180);
  }

  function comparableUrl(url) {
    var parsedUrl = new URL(url, window.location.origin);
    return parsedUrl.pathname.replace(/\/$/, '') + parsedUrl.search;
  }

  function crossesDepartmentTemplate(url) {
    var targetUrl = new URL(url, window.location.origin);
    var targetIsSearch = targetUrl.pathname.indexOf('/search') > -1;
    var currentIsSearch = window.location.pathname.indexOf('/search') > -1;
    return targetIsSearch !== currentIsSearch;
  }

  function setActiveDepartmentFilter(nav, url) {
    var activeUrl = comparableUrl(url);

    nav.querySelectorAll(departmentFilterSelector).forEach(function (link) {
      var linkUrl = new URL(link.href || link.dataset.url, window.location.origin);
      var isActive = !linkUrl.hash && comparableUrl(link.href || link.dataset.url) === activeUrl;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function hillsideCategoryFromUrl(url) {
    var categoryMatch = new URL(url, window.location.origin).hash.match(/^#dms-category-([a-z-]+)$/);
    return categoryMatch ? categoryMatch[1] : 'all';
  }

  function applyHillsideCategory(layout, nav, category, animate) {
    var program = nav.dataset.dmsHillsideProgram;
    var grid = layout.querySelector(productGridSelector);
    if (!program || !grid) return;

    if (animate) {
      layout.classList.add('dms-category-is-loading');
      grid.setAttribute('aria-busy', 'true');
    }

    nav.querySelectorAll('[data-dms-hillside-category]').forEach(function (link) {
      var isActive = link.dataset.dmsHillsideCategory === category;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    window.setTimeout(function () {
      var visibleCount = 0;
      grid.querySelectorAll('[data-product-block]').forEach(function (card) {
        var productLink = card.querySelector('[data-grid-link][aria-label]');
        var productTitle = productLink ? productLink.getAttribute('aria-label').toLowerCase() : '';
        var matchesProgram = productTitle.indexOf('hillside ' + program) > -1;
        var matchesCategory = category === 'all' || productTitle.indexOf(category) > -1;
        var isVisible = matchesProgram && matchesCategory;

        card.hidden = !isVisible;
        card.classList.remove('dms-hillside-product-reveal');
        if (isVisible) {
          visibleCount += 1;
          window.requestAnimationFrame(function () {
            card.classList.add('dms-hillside-product-reveal');
          });
        }
      });

      var emptyState = grid.querySelector('.dms-hillside-empty');
      if (visibleCount === 0 && !emptyState) {
        emptyState = document.createElement('div');
        emptyState.className = 'dms-hillside-empty';
        emptyState.innerHTML = '<p>Coming soon</p><h3>No ' + program.charAt(0).toUpperCase() + program.slice(1) + ' products yet</h3><p>We’ll add products here as soon as inventory is ready.</p>';
        var productList = grid.querySelector('.grid') || grid;
        productList.appendChild(emptyState);
      } else if (visibleCount > 0 && emptyState) {
        emptyState.remove();
      }

      layout.classList.remove('dms-category-is-loading');
      grid.removeAttribute('aria-busy');
    }, animate ? 90 : 0);
  }

  function revealDepartmentAnchor(hash, attempt) {
    var target = document.querySelector(hash);
    if (!target && attempt < 40) {
      window.setTimeout(function () { revealDepartmentAnchor(hash, attempt + 1); }, 75);
      return;
    }
    if (!target) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    target.classList.remove('dms-anchor-arrival');
    window.requestAnimationFrame(function () {
      target.classList.add('dms-anchor-arrival');
      window.setTimeout(function () { target.classList.remove('dms-anchor-arrival'); }, 900);
    });
  }

  function keepDepartmentNavMounted(layout, nav) {
    var filters = layout.querySelector(filtersSelector);
    if (!filters) return null;

    var restoreNav = function () {
      var form = filters.querySelector(filtersFormSelector);
      if (!form) return;

      filters.querySelectorAll('.dms-department-filters').forEach(function (currentNav) {
        if (currentNav !== nav) currentNav.remove();
      });

      if (nav.parentNode !== form || form.firstElementChild !== nav) {
        form.prepend(nav);
      }
    };

    var observer = new MutationObserver(restoreNav);
    observer.observe(filters, { childList: true, subtree: true });
    restoreNav();
    return observer;
  }

  function finishDepartmentTransition(layout, nav) {
    window.requestAnimationFrame(function () {
      layout.classList.remove('dms-category-is-loading');
      nav.removeAttribute('aria-busy');

      var grid = layout.querySelector(productGridSelector);
      if (grid) grid.removeAttribute('aria-busy');
    });
  }

  function beginDepartmentTransition(layout, nav) {
    layout.classList.add('dms-category-is-loading');
    nav.setAttribute('aria-busy', 'true');

    var grid = layout.querySelector(productGridSelector);
    if (grid) grid.setAttribute('aria-busy', 'true');

    return grid;
  }

  function renderDepartmentUrl(layout, nav, url, updateHistory) {
    var targetUrl = new URL(url, window.location.origin);
    preloadDepartmentPage(layout, targetUrl.href);
    var grid = beginDepartmentTransition(layout, nav);
    var previousScrollTop = window.scrollY;
    var hasRendered = false;

    setActiveDepartmentFilter(nav, targetUrl.href);

    var gridObserver = new MutationObserver(function (mutations) {
      var productContentChanged = mutations.some(function (mutation) {
        return mutation.type === 'childList';
      });

      if (!productContentChanged) return;
      hasRendered = true;
      gridObserver.disconnect();
      finishDepartmentTransition(layout, nav);
    });

    if (grid) gridObserver.observe(grid, { childList: true });

    if (updateHistory) {
      window.history.pushState(
        { searchParams: targetUrl.searchParams.toString(), dmsDepartmentFilter: true },
        '',
        targetUrl.pathname + targetUrl.search
      );
    }

    var nativeScrollTo = window.scrollTo;
    window.scrollTo = function () {
      var settings = arguments[0];
      if (settings && typeof settings === 'object' && settings.behavior === 'smooth') return;
      return nativeScrollTo.apply(window, arguments);
    };

    try {
      window.dispatchEvent(new PopStateEvent('popstate', {
        state: {
          searchParams: targetUrl.searchParams.toString(),
          dmsDepartmentFilter: true
        }
      }));
    } finally {
      window.scrollTo = nativeScrollTo;
    }

    // The theme normally scrolls to the product grid while filtering. Keeping
    // the current position makes the persistent category rail feel seamless.
    window.scrollTo({ top: previousScrollTop, left: 0, behavior: 'auto' });

    window.setTimeout(function () {
      if (!hasRendered) {
        gridObserver.disconnect();
        finishDepartmentTransition(layout, nav);
      }
    }, 5000);
  }

  function initDepartmentFilters() {
    document.querySelectorAll(departmentLayoutSelector).forEach(function (layout) {
      var nav = layout.querySelector('.dms-department-filters');
      if (!nav || nav.dataset.ajaxReady === 'true') return;

      nav.dataset.ajaxReady = 'true';
      keepDepartmentNavMounted(layout, nav);
      scheduleDepartmentPreloads(layout, nav);

      if (nav.dataset.dmsHillsideProgram) {
        applyHillsideCategory(layout, nav, hillsideCategoryFromUrl(window.location.href), false);

        var hillsideGridObserver = new MutationObserver(function (mutations) {
          var productGridChanged = mutations.some(function (mutation) {
            return mutation.type === 'childList';
          });
          if (productGridChanged) {
            applyHillsideCategory(layout, nav, hillsideCategoryFromUrl(window.location.href), false);
          }
        });
        hillsideGridObserver.observe(layout, { childList: true, subtree: true });
      }

      var preloadFromEvent = function (event) {
        if (!(event.target instanceof Element)) return;
        var link = event.target.closest(departmentFilterSelector);
        if (link && nav.contains(link) && !crossesDepartmentTemplate(link.href || link.dataset.url)) {
          preloadDepartmentPage(layout, link.href || link.dataset.url);
        }
      };

      nav.addEventListener('pointerover', preloadFromEvent, { passive: true });
      nav.addEventListener('focusin', preloadFromEvent);

      document.addEventListener('click', function (event) {
        if (!(event.target instanceof Element)) return;
        var link = event.target.closest(departmentFilterSelector);
        if (!link || !nav.contains(link)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var targetUrl = new URL(link.href || link.dataset.url, window.location.origin);
        if (link.dataset.dmsHillsideCategory) {
          event.preventDefault();
          if (layout.classList.contains('dms-category-is-loading')) return;

          window.history.pushState(
            { dmsHillsideCategory: true },
            '',
            targetUrl.pathname + targetUrl.search + targetUrl.hash
          );
          applyHillsideCategory(layout, nav, link.dataset.dmsHillsideCategory, true);
          return;
        }

        var isFilterResultsPage = targetUrl.pathname.indexOf('/collections/') > -1 || targetUrl.pathname.indexOf('/search') > -1;
        if (!isFilterResultsPage) return;
        if (targetUrl.hash) {
          event.preventDefault();
          var existingTarget = document.querySelector(targetUrl.hash);
          if (existingTarget) {
            revealDepartmentAnchor(targetUrl.hash, 0);
            return;
          }
          if (crossesDepartmentTemplate(targetUrl.href)) {
            window.location.href = link.href || link.dataset.url;
            return;
          }
          renderDepartmentUrl(layout, nav, targetUrl.href, true);
          revealDepartmentAnchor(targetUrl.hash, 0);
          return;
        }
        if (crossesDepartmentTemplate(targetUrl.href)) return;

        event.preventDefault();
        if (layout.classList.contains('dms-category-is-loading')) return;
        if (comparableUrl(link.href || link.dataset.url) === comparableUrl(window.location.href)) return;

        renderDepartmentUrl(layout, nav, link.href || link.dataset.url, true);
      });

      window.addEventListener('popstate', function (event) {
        if (event.state && event.state.dmsDepartmentFilter) return;
        if (!document.documentElement.contains(layout)) return;

        if (nav.dataset.dmsHillsideProgram) {
          applyHillsideCategory(layout, nav, hillsideCategoryFromUrl(window.location.href), true);
          return;
        }

        setActiveDepartmentFilter(nav, window.location.href);
        beginDepartmentTransition(layout, nav);

        window.setTimeout(function () {
          finishDepartmentTransition(layout, nav);
        }, 700);
      });
    });
  }

  function initPremiumMotion() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var revealSelector = [
      '.dms-section-heading > *',
      '.dms-spotlight__media',
      '.dms-spotlight__content',
      '.dms-product-card',
      '.dms-category-card',
      '.dms-school-program-card',
      '.dms-story__media',
      '.dms-story__content',
      '.dms-custom-order__intro',
      '.dms-order-form',
      '.dms-value',
      '.dms-assurance-card',
      '.dms-department-contact__inner',
      '[data-collection-products] [data-product-block]'
    ].join(',');

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
        var revealDelay = parseInt(entry.target.style.getPropertyValue('--dms-reveal-delay'), 10) || 0;
        window.setTimeout(function () {
          entry.target.classList.remove('dms-reveal');
        }, 1900 + revealDelay);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -7% 0px'
    });

    function revealDelayFor(element) {
      var parent = element.parentElement;
      if (!parent) return 0;
      var siblings = Array.from(parent.children).filter(function (child) {
        return child.matches && child.matches(revealSelector);
      });
      var index = siblings.indexOf(element);
      return Math.min(Math.max(index, 0) * 80, 320);
    }

    function hydrateRevealElements(root) {
      var elements = [];
      if (root instanceof Element && root.matches(revealSelector)) elements.push(root);
      if (root.querySelectorAll) elements = elements.concat(Array.from(root.querySelectorAll(revealSelector)));

      elements.forEach(function (element) {
        if (element.dataset.dmsMotionReady === 'true') return;
        element.dataset.dmsMotionReady = 'true';
        element.classList.add('dms-reveal');
        element.style.setProperty('--dms-reveal-delay', revealDelayFor(element) + 'ms');
        revealObserver.observe(element);
      });
    }

    document.documentElement.classList.add('dms-motion-ready');
    hydrateRevealElements(document);

    var hero = document.querySelector('.dms-hero');
    if (hero) {
      Array.from(hero.querySelectorAll('.dms-hero__content > *')).forEach(function (element, index) {
        element.classList.add('dms-hero-intro');
        element.style.setProperty('--dms-hero-intro-delay', (175 + index * 150) + 'ms');
      });

      var heroFrame = 0;
      var updateHeroDepth = function () {
        heroFrame = 0;
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = Math.min(Math.max(-rect.top / Math.max(rect.height, 1), 0), 1);
        hero.style.setProperty('--dms-hero-shift', (progress * 30).toFixed(2) + 'px');
      };
      var requestHeroDepth = function () {
        if (heroFrame) return;
        heroFrame = window.requestAnimationFrame(updateHeroDepth);
      };

      updateHeroDepth();
      window.addEventListener('scroll', requestHeroDepth, { passive: true });
      window.addEventListener('resize', requestHeroDepth, { passive: true });
    }

    var motionMutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) hydrateRevealElements(node);
        });
      });
    });
    motionMutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initInquirySwitches(root) {
    var scope = root || document;
    var inquirySections = [];
    if (scope instanceof Element && scope.matches('[data-dms-inquiry]')) inquirySections.push(scope);
    if (scope.querySelectorAll) inquirySections = inquirySections.concat(Array.from(scope.querySelectorAll('[data-dms-inquiry]')));

    inquirySections.forEach(function (section) {
      if (section.dataset.inquiryReady === 'true') return;
      section.dataset.inquiryReady = 'true';

      var form = section.querySelector('form');
      var submitButton = section.querySelector('[data-inquiry-submit]');
      var tagsField = section.querySelector('[data-inquiry-tags]');
      var typeField = section.querySelector('[data-inquiry-type]');
      var successMessage = section.querySelector('[data-inquiry-success]');
      var storageKey = 'dms-inquiry-mode-' + (section.closest('[data-section-id]') || section).getAttribute('data-section-id');

      function setMode(mode) {
        var selectedMode = mode === 'question' ? 'question' : 'request';
        section.dataset.inquiryMode = selectedMode;

        section.querySelectorAll('[data-inquiry-mode-button]').forEach(function (button) {
          var isActive = button.dataset.inquiryModeButton === selectedMode;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-inquiry-panel]').forEach(function (panel) {
          var isActive = panel.dataset.inquiryPanel === selectedMode;
          panel.hidden = !isActive;
          panel.querySelectorAll('input, select, textarea').forEach(function (field) {
            field.disabled = !isActive;
          });
        });

        if (tagsField) tagsField.value = selectedMode === 'question' ? 'General question, Website' : 'Custom order request, Website';
        if (typeField) typeField.value = selectedMode === 'question' ? 'Question' : 'Request';
        if (submitButton) submitButton.textContent = selectedMode === 'question' ? submitButton.dataset.questionLabel : submitButton.dataset.requestLabel;
        if (successMessage) successMessage.textContent = selectedMode === 'question' ? successMessage.dataset.questionMessage : successMessage.dataset.requestMessage;
      }

      section.querySelectorAll('[data-inquiry-mode-button]').forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.dataset.inquiryModeButton);
        });
      });

      if (form) {
        form.addEventListener('submit', function () {
          try { window.sessionStorage.setItem(storageKey, section.dataset.inquiryMode); } catch (error) { }
        });
      }

      var savedMode = 'request';
      try { savedMode = window.sessionStorage.getItem(storageKey) || savedMode; } catch (error) { }
      setMode(savedMode);
    });
  }

  function initCuttingBoardShop(scope) {
    (scope || document).querySelectorAll('[data-board-shop]').forEach(function (shop) {
      if (shop.dataset.boardShopReady) return;
      shop.dataset.boardShopReady = 'true';

      // ── Tab switching: Order by Picture vs Choose Board Design ──
      var tabs = Array.from(shop.querySelectorAll('[data-shop-tab]'));
      var tabPanels = {
        picture: shop.querySelector('[data-shop-panel="picture"]'),
        dropdown: shop.querySelector('[data-shop-panel="dropdown"]')
      };
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var mode = tab.dataset.shopTab; // 'picture' or 'dropdown'
          tabs.forEach(function (t) {
            var isActive = t.dataset.shopTab === mode;
            t.classList.toggle('dms-board-shop__tab--active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          Object.keys(tabPanels).forEach(function (key) {
            if (tabPanels[key]) tabPanels[key].hidden = (key !== mode);
          });
        });
      });

      // ── Design card grid (Order by Picture) ──
      var designCards = Array.from(shop.querySelectorAll('[data-design-card]'));
      var panels = Array.from(shop.querySelectorAll('[data-board-panel]'));
      var chooser = shop.querySelector('[data-board-design]');

      function selectBoard(handle, updateUrl) {
        var selected = panels.find(function (panel) { return panel.dataset.boardPanel === handle; });
        if (!selected) return;
        panels.forEach(function (panel) { panel.hidden = panel !== selected; });
        // Sync design cards
        designCards.forEach(function (card) {
          var isActive = card.dataset.designCard === handle;
          card.classList.toggle('dms-board-shop__design-card--active', isActive);
          card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        // Sync dropdown
        if (chooser) chooser.value = handle;
        // Trigger live price & summary sync for selected customizer
        var customizer = selected.querySelector('.dms-cutting-board-customizer');
        if (customizer && customizer.__updateCbPrices) {
          customizer.__updateCbPrices();
        }
        if (updateUrl) window.history.replaceState(null, '', '#board-' + encodeURIComponent(handle));
      }

      designCards.forEach(function (card) {
        card.addEventListener('click', function () {
          selectBoard(card.dataset.designCard, true);
        });
      });

      if (chooser) {
        chooser.addEventListener('change', function () { selectBoard(chooser.value, true); });
      }

      shop.querySelectorAll('[data-switch-board]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var target = btn.getAttribute('data-switch-board');
          selectBoard(target, true);
          var targetPanel = shop.querySelector('[data-board-panel="' + target + '"]');
          if (targetPanel) {
            targetPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      function fromHash() {
        if (window.location.hash.indexOf('#board-') !== 0) return;
        try { selectBoard(decodeURIComponent(window.location.hash.slice(7)), false); } catch (error) { }
      }
      window.addEventListener('hashchange', fromHash);
      fromHash();

      // ── Wood variant select change ──
      shop.querySelectorAll('[data-board-variant]').forEach(function (select) {
        select.addEventListener('change', function () {
          var option = select.options[select.selectedIndex];
          var panel = select.closest('[data-board-panel]');
          var button = panel ? panel.querySelector('[data-board-add]') : null;
          if (button) {
            button.disabled = option.dataset.available !== 'true';
            button.textContent = button.disabled ? 'Sold out' : 'Add to Cart';
          }
          var photo = panel ? panel.querySelector('.dms-board-shop__photo') : null;
          if (photo && option.dataset.image) {
            photo.removeAttribute('srcset');
            photo.src = option.dataset.image;
          }
          var customizer = panel ? panel.querySelector('.dms-cutting-board-customizer') : null;
          if (customizer && customizer.__updateCbPrices) {
            customizer.__updateCbPrices();
          }
        });
      });
    });
  }

  /* ─── Cutting Board Customizer Logic ─── */
  var CB_PRICING = {
    'multi-color':  { '12x16': 70, '12x18': 80, '12x20': 90 },
    'zigzag':       { '12x16': 80, '12x18': 90, '12x20': 100 }
  };

  var CB_SIZE_LABELS = {
    '12x16': '12" × 16"',
    '12x18': '12" × 18"',
    '12x20': '12" × 20"'
  };

  function initCuttingBoardCustomizers(scope) {
    var container = scope || document;
    var customizers = container.querySelectorAll('.dms-cutting-board-customizer');
    if (!customizers.length) return;

    var STYLE_NAMES = {
      'striped-engraved': 'Striped + Engraved',
      'zigzag': 'Zig-Zag',
      'zigzag-striped': 'Zig-Zag + Striped',
      'alternating': 'Alternating',
      'alternating-sides': 'Alternating × Sides'
    };

    customizers.forEach(function (customizer) {
      if (customizer.dataset.cbReady === 'true') return;
      customizer.dataset.cbReady = 'true';
      var boardType = customizer.getAttribute('data-board-type') || 'striped'; // 'striped' | 'zigzag'
      var boardDesign = customizer.getAttribute('data-board-design') || 'alternating';

      // Coherent wood slot selects
      var woodSlotSelects = customizer.querySelectorAll('[data-cb-wood-slot]');
      var selectedWoodsDisplay = customizer.querySelector('[data-cb-selected-woods-display]');

      // Legacy wood chips (fallback if present)
      var woodChips = customizer.querySelectorAll('[data-cb-wood-chip]');
      var woodInputs = customizer.querySelectorAll('[data-cb-wood-input]');
      var woodCountLabel = customizer.querySelector('[data-cb-wood-count-label]');
      var woodStatus = customizer.querySelector('[data-cb-wood-status]');
      var woodStatusText = customizer.querySelector('[data-cb-wood-status-text]');
      var requiredWoods = parseInt(customizer.getAttribute('data-required-woods'), 10) || 3;

      var styleInputs = customizer.querySelectorAll('[data-cb-style-input]');
      var sizePills = customizer.querySelectorAll('.dms-cb-size-pill');
      var grooveCheckbox = customizer.querySelector('[data-cb-addon="groove"]');
      var engravingCheckbox = customizer.querySelector('[data-cb-addon="engraving"]');
      var engravingPanel = customizer.querySelector('[data-cb-engraving-panel]');
      var engravingTextInput = customizer.querySelector('[data-cb-engraving-text]');
      var engravingPlacementSelect = customizer.querySelector('[data-cb-engraving-placement]');
      var engravingFileInput = customizer.querySelector('[data-cb-engraving-file]');

      var selectedStyleLabel = customizer.querySelector('[data-cb-selected-style-label]');
      var selectedSizeLabel = customizer.querySelector('[data-cb-selected-size-label]');
      var summaryBadge = customizer.querySelector('[data-cb-summary-badge]');
      var summaryAddons = customizer.querySelector('[data-cb-summary-addons]');
      var summaryTotal = customizer.querySelector('[data-cb-summary-total]');

      var propStyle = customizer.querySelector('[data-cb-prop-style]');
      var propWood = customizer.querySelector('[data-cb-prop-wood-type]');
      var propWoodSpecies = customizer.querySelector('[data-cb-prop-wood-species]');
      var propSize = customizer.querySelector('[data-cb-prop-size]');
      var propGroove = customizer.querySelector('[data-cb-prop-groove]');
      var propEngraving = customizer.querySelector('[data-cb-prop-engraving]');
      var propEngravingText = customizer.querySelector('[data-cb-prop-engraving-text]');
      var propEngravingPlacement = customizer.querySelector('[data-cb-prop-engraving-placement]');
      var propTotalPrice = customizer.querySelector('[data-cb-prop-total-price]');

      var activePill = customizer.querySelector('.dms-cb-size-pill--active');
      var currentSize = activePill ? (activePill.getAttribute('data-cb-size') || '12x16') : '12x16';

      function getWoodData() {
        if (woodSlotSelects.length > 0) {
          var parts = [];
          var shortNames = [];
          woodSlotSelects.forEach(function (sel) {
            var slotName = sel.getAttribute('data-cb-wood-slot') || '';
            var val = sel.value || (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].text) || '';
            var cleanVal = val.split('(')[0].trim();
            parts.push(slotName + ': ' + cleanVal);
            if (shortNames.indexOf(cleanVal) === -1) shortNames.push(cleanVal);
          });
          var detailedSummary = parts.join(' • ');
          var shortBadge = shortNames.join(', ');
          return { summary: detailedSummary, badge: shortBadge, raw: parts };
        } else if (woodInputs.length > 0) {
          var selected = [];
          woodInputs.forEach(function (inp) {
            if (inp.checked) selected.push(inp.value);
          });
          return { summary: selected.join(' + '), badge: selected.join(', '), raw: selected };
        }
        return { summary: '', badge: '', raw: [] };
      }

      function updateWoodDisplay() {
        var woodData = getWoodData();
        if (selectedWoodsDisplay && woodData.summary) {
          selectedWoodsDisplay.textContent = woodData.summary;
        }
        if (propWood && woodData.summary) propWood.value = woodData.summary;
        if (propWoodSpecies && woodData.summary) propWoodSpecies.value = woodData.summary;
      }

      // Attach change listeners to coherent wood dropdowns
      woodSlotSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          updateWoodDisplay();
          updatePrices();
        });
      });

      // Legacy wood chips handling
      if (woodChips.length > 0) {
        function updateLegacyWoodUI() {
          var selected = [];
          woodInputs.forEach(function (inp) { if (inp.checked) selected.push(inp.value); });
          var count = selected.length;
          if (woodCountLabel) woodCountLabel.textContent = count + ' of ' + requiredWoods + ' selected';
          woodChips.forEach(function (chip) {
            var inp = chip.querySelector('[data-cb-wood-input]');
            chip.classList.toggle('is-selected', !!(inp && inp.checked));
          });
          if (woodStatusText) {
            if (count === requiredWoods) {
              woodStatusText.textContent = 'Selected: ' + selected.join(' + ');
              if (woodStatus) woodStatus.className = 'dms-cb-wood-status';
            } else {
              var rem = requiredWoods - count;
              woodStatusText.textContent = 'Please select ' + rem + ' more wood type' + (rem > 1 ? 's' : '');
              if (woodStatus) woodStatus.className = 'dms-cb-wood-status dms-cb-wood-status--notice';
            }
          }
          updatePrices();
        }

        woodChips.forEach(function (chip) {
          var inp = chip.querySelector('[data-cb-wood-input]');
          if (!inp) return;
          chip.addEventListener('click', function (e) {
            if (e.target !== inp) { e.preventDefault(); inp.checked = !inp.checked; }
            var selCount = Array.from(woodInputs).filter(function (i) { return i.checked; }).length;
            if (inp.checked && selCount > requiredWoods) {
              inp.checked = false;
              chip.classList.add('dms-cb-wood-shake');
              setTimeout(function () { chip.classList.remove('dms-cb-wood-shake'); }, 400);
              return;
            }
            updateLegacyWoodUI();
          });
        });
      }

      function updatePrices() {
        var pricingCategory = 'multi-color';
        if (boardType === 'zigzag' || boardDesign === 'zigzag' || boardDesign === 'zigzag-striped') {
          pricingCategory = 'zigzag';
        }

        var basePrices = CB_PRICING[pricingCategory];
        var basePrice = (basePrices && basePrices[currentSize]) || (pricingCategory === 'zigzag' ? 80 : 70);
        var styleName = STYLE_NAMES[boardDesign] || (pricingCategory === 'zigzag' ? 'Zig-Zag' : 'Alternating Stripe');

        // Update size pill prices
        sizePills.forEach(function (pill) {
          var sz = pill.getAttribute('data-cb-size');
          var pEl = pill.querySelector('[data-price-size]');
          if (pEl && sz && basePrices && basePrices[sz]) {
            pEl.textContent = '$' + basePrices[sz];
          }
        });

        var hasGroove = grooveCheckbox ? grooveCheckbox.checked : false;
        var hasEngraving = engravingCheckbox ? engravingCheckbox.checked : false;

        var addonsTotal = 0;
        var addonsList = [];
        if (hasGroove) {
          addonsTotal += 5;
          addonsList.push('Juice Groove (+$5)');
        }
        if (hasEngraving) {
          addonsTotal += 5;
          addonsList.push('Laser Engraving (+$5)');
        }

        var totalPrice = basePrice + addonsTotal;
        var formattedTotal = '$' + totalPrice + '.00';

        var woodData = getWoodData();

        // Update labels and display
        var sizeDisplayName = CB_SIZE_LABELS[currentSize] || currentSize;
        if (selectedSizeLabel) selectedSizeLabel.textContent = sizeDisplayName;
        if (selectedStyleLabel) selectedStyleLabel.textContent = styleName;

        var badgeParts = [sizeDisplayName];
        if (woodData.badge) badgeParts.push(woodData.badge);
        if (styleName) badgeParts.push(styleName);
        if (summaryBadge) summaryBadge.textContent = badgeParts.join(' • ');

        if (summaryAddons) {
          summaryAddons.textContent = addonsList.length ? addonsList.join(' + ') : 'No add-ons selected';
        }
        if (summaryTotal) summaryTotal.textContent = formattedTotal;

        // Update hidden inputs for Shopify order line item properties
        if (propStyle) propStyle.value = styleName;
        if (propWood && woodData.summary) propWood.value = woodData.summary;
        if (propWoodSpecies && woodData.summary) propWoodSpecies.value = woodData.summary;
        if (propSize) propSize.value = sizeDisplayName + ' (' + currentSize + ')';
        if (propGroove) propGroove.value = hasGroove ? 'Yes (+$5.00)' : 'No';
        if (propEngraving) propEngraving.value = hasEngraving ? 'Yes (+$5.00)' : 'No';
        if (propTotalPrice) propTotalPrice.value = formattedTotal;

        // Update main product price display on the board panel
        var panel = customizer.closest('[data-board-panel], .product-single__wrapper, .product, body');
        var productPriceElement = panel ? panel.querySelector('[data-product-price], .product__price span') : null;
        if (productPriceElement) {
          productPriceElement.textContent = formattedTotal;
        }
        customizer.dispatchEvent(new CustomEvent('dms:board:updated'));
      }

      customizer.__updateCbPrices = updatePrices;

      // Size selection
      sizePills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          sizePills.forEach(function (p) {
            p.classList.remove('dms-cb-size-pill--active');
            p.setAttribute('aria-checked', 'false');
            p.tabIndex = -1;
          });
          pill.classList.add('dms-cb-size-pill--active');
          pill.setAttribute('aria-checked', 'true');
          pill.tabIndex = 0;
          currentSize = pill.getAttribute('data-cb-size');
          updatePrices();
        });
        pill.addEventListener('keydown', function (event) {
          var index = Array.prototype.indexOf.call(sizePills, pill);
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % sizePills.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index + sizePills.length - 1) % sizePills.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = sizePills.length - 1;
          else return;
          event.preventDefault();
          sizePills[index].click();
          sizePills[index].focus();
        });
      });

      // Style selection (for striped boards)
      styleInputs.forEach(function (radio) {
        radio.addEventListener('change', function () {
          updatePrices();
        });
      });

      // Juice groove toggle
      if (grooveCheckbox) {
        var grooveCard = customizer.querySelector('#dms-cb-groove-card-' + (customizer.id.replace('dms-cutting-board-customizer-', '')));
        var groovePreview = customizer.querySelector('[data-cb-addon-preview="groove"]');
        if (grooveCard) grooveCard.classList.toggle('dms-cb-addon-card--active', grooveCheckbox.checked);
        if (groovePreview) groovePreview.style.display = grooveCheckbox.checked ? 'block' : 'none';

        grooveCheckbox.addEventListener('change', function () {
          if (grooveCard) grooveCard.classList.toggle('dms-cb-addon-card--active', grooveCheckbox.checked);
          if (groovePreview) groovePreview.style.display = grooveCheckbox.checked ? 'block' : 'none';
          updatePrices();
        });
      }

      // Engraving toggle
      if (engravingCheckbox) {
        var engCard = customizer.querySelector('#dms-cb-engraving-card-' + (customizer.id.replace('dms-cutting-board-customizer-', '')));
        if (engCard) engCard.classList.toggle('dms-cb-addon-card--active', engravingCheckbox.checked);
        if (engravingPanel) engravingPanel.style.display = engravingCheckbox.checked ? 'block' : 'none';
        engravingCheckbox.setAttribute('aria-expanded', engravingCheckbox.checked ? 'true' : 'false');

        engravingCheckbox.addEventListener('change', function () {
          if (engCard) engCard.classList.toggle('dms-cb-addon-card--active', engravingCheckbox.checked);
          if (engravingPanel) engravingPanel.style.display = engravingCheckbox.checked ? 'block' : 'none';
          engravingCheckbox.setAttribute('aria-expanded', engravingCheckbox.checked ? 'true' : 'false');
          updatePrices();
        });
      }

      // Engraving text & placement inputs
      if (engravingTextInput && propEngravingText) {
        engravingTextInput.addEventListener('input', function () {
          propEngravingText.value = engravingTextInput.value;
        });
      }

      if (engravingPlacementSelect && propEngravingPlacement) {
        engravingPlacementSelect.addEventListener('change', function () {
          propEngravingPlacement.value = engravingPlacementSelect.value;
        });
        propEngravingPlacement.value = engravingPlacementSelect.value;
      }

      // If file input provided for engraving
      if (engravingFileInput) {
        engravingFileInput.addEventListener('change', function () {
          var formId = customizer.getAttribute('data-product-form-id');
          if (formId) {
            engravingFileInput.setAttribute('form', formId);
            engravingFileInput.setAttribute('name', 'properties[Engraving Logo File]');
          }
        });
      }

      // Initialize defaults
      updateWoodDisplay();
      updatePrices();
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initDepartmentFilters();
    initPremiumMotion();
    initInquirySwitches(document);
    initCuttingBoardCustomizers(document);
    initCuttingBoardShop(document);
  });
} else {
  initDepartmentFilters();
  initPremiumMotion();
  initInquirySwitches(document);
  initCuttingBoardCustomizers(document);
  initCuttingBoardShop(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initInquirySwitches(event.target);
  initCuttingBoardCustomizers(event.target);
  initCuttingBoardShop(event.target);
});
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
}) ();
